import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, RouterOutlet, ActivatedRouteSnapshot } from '@angular/router';
import { RoutePartsService } from './services/api/route-parts.service';
import { filter, Subscription } from 'rxjs';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthService } from './services/auth/auth.service';
import { AuthStateService } from './services/auth/auth-state.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy {
  appTitle = 'Sisweb 4.1 | Sweaden Seguros';
  pageTitle = '';
  private idleSub?: Subscription;
  private titleSub?: Subscription;

  constructor(
    public title: Title,
    private readonly router: Router,
    private readonly routePartsService: RoutePartsService,
    private readonly bnIdle: BnNgIdleService,
    private readonly authService: AuthService,
    private readonly authState: AuthStateService,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    void this.inicializarSesion();
    this.idleSub = this.bnIdle.startWatching(900).subscribe(async (isTimedOut: boolean) => {
      const user = localStorage.getItem('usuarioSistema');
      if (user === 'cotizador' && isTimedOut) {
        await this.router.navigateByUrl('/cotizador');
      } else if (user != 'cotizador' && isTimedOut) {
        await this.authService.cerrarSesion();
        this.idleSub?.unsubscribe();
      }
    });

    this.changePageTitle();
  }

  private async inicializarSesion(): Promise<void> {
    await this.authState.rehidratarDesdeIndexedDB();
  }

  changePageTitle(): void {
    this.titleSub = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      try {
        const routeParts = this.routePartsService.generateRouteParts(
          this.getDeepestSnapshot(this.router.routerState.snapshot.root),
        );

        if (!routeParts.length) {
          this.title.setTitle(this.appTitle);
          return;
        }

        this.pageTitle = routeParts.map((part) => part.title).reduce((partA, partI) => `${partA} > ${partI}`, '');

        this.pageTitle += ` | ${this.appTitle}`;
        this.title.setTitle(this.pageTitle);
      } catch (error) {
        console.warn('[AppComponent] Error generando título dinámico:', error);
        this.title.setTitle(this.appTitle);
      }
    });
  }

  private getDeepestSnapshot(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let current = snapshot;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current;
  }

  ngOnDestroy(): void {
    this.idleSub?.unsubscribe();
    this.titleSub?.unsubscribe();
  }
}
